<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'name', validatorRules.name]" placeholder="请输入名称"></a-input>
        </a-form-item>
        <a-form-item label="一级分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['category', validatorRules.category]" :trigger-change="true" dictCode="brand_strength_one" placeholder="请选择一级分类"  @change="selectDictOneChange"  />
        </a-form-item>
        <a-form-item label="二级分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['detailCategory', validatorRules.category]" :trigger-change="true"  placeholder="请选择二级分类"  ref="detailCategoryRef" />
        </a-form-item>
        <a-form-item label="封面图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-image-upload v-decorator="['coverPicture', validatorRules.coverPicture]" :fileType="fileType"  bizPath="patent"  ></j-image-upload>
          <!-- <j-upload v-decorator="['coverPicture', validatorRules.coverPicture]" :trigger-change="true"></j-upload> -->
        </a-form-item>
        <a-form-item label="详细描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-editor ref="jEditorRef" v-decorator="['detailDescription',validatorRules.detailDescription]"/>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import { queryDetailCategoryListByCategory  } from "@/api/api"
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JUpload from '@/components/jeecg/JUpload'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JEditor from '@/components/jeecg/JEditorChangeUrl'
  import JImageUpload from '@/components/jeecg/JImageUpload'

  export default {
    name: "BusGisBrandPowerModal",
    components: { 
      JImageUpload,
      JUpload,
      JDictSelectTag,
      JEditor,
    },
    data () {
      return {
        fileType:'huayun',
        imgList:[],
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          name: {rules: [
            {required: true, message: '请输入名称!'},
          ]},
          category: {rules: [
            {required: true, message: '请输入一级分类!'},
          ]},
          detailCategory: {rules: [
            {required: true, message: '请输入二级分类!'},
          ]},
          coverPicture: {rules: [
            {required: true, message: '请输入封面图片!'},
          ]},
          detailDescription: {rules: [
            {required: true, message: '请输入详细描述!'},
          ],
          trigger:'input'
          },
        },
        url: {
          add: "/base/busGisBrandPower/add",
          edit: "/base/busGisBrandPower/edit",
        },
        dictTwoOptions1:[]
      }
    },
    created () {
    },
    mounted() {
    },
    methods: {
      add () {
        this.imgList=""
        this.edit({});
      },
      edit (record) {
        if(record.category){
          this.selectDictOneChange(record.category)
        }
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'name','category','detailCategory','coverPicture','detailDescription'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'name','category','detailCategory','coverPicture','detailDescription'))
      },
      selectDictOneChange(val){
        this.validatorRules.detailCategory=""
        this.dictTwoOptions1=[]
        queryDetailCategoryListByCategory({
            category:val
        }).then(res=>{
          if(res.code==200){
            if(res.result.length>0){
              for (const key of res.result) {
                this.dictTwoOptions1.push({
                  text:key.item_text,
                  value:key.item_value
                })
              }
            }else{
              this.$message.success("暂无该分类下的数据")
            }
            this.$refs.detailCategoryRef.setCurrentDictOptions(this.dictTwoOptions1)
          }else{
            this.$message.error(res.message)
          }
        }).catch(err=>{
          this.$message.error(err)
        })
      },
      
    }
  }
</script>